import React from "react";
import "../../App.css";
import PartyReport from "../PartyReport";

function PartyReportPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("party_report")){
    return;}
  return (
    <div className="page-mr">
      <PartyReport sessionObject={sessionObject} />
    </div>
  );
}

export default PartyReportPage;
